import $ from "jquery";

const splashScreen = () => {
  const init = () => {
    splash();
  };

  const splash = () => {
    const el = {
      body: ".home.page-template",
      screen: "#splash-screen",
      icon: "#splash-screen-icon",
      title: "#splash-screen-title",
    };

    if (sessionStorage.getItem("splash") !== "true") {
      $(window).on("load", () => {
        $(el.body).addClass("static");

        setTimeout(() => {
          $(el.icon).addClass("show");
        }, 500);

        setTimeout(() => {
          $(el.title).addClass("show");
        }, 1500);

        setTimeout(() => {
          $(el.screen).addClass("dissapear");
          $(el.body).removeClass("static");
        }, 3000);
      });

      sessionStorage.setItem("splash", "true");
    } else {
      $(el.screen).addClass("dissapear");
    }
  };

  init();
};

try {
  splashScreen();
} catch (e) {
  console.log(e);
}
